import React, {useEffect, useState} from 'react';
import agent from '../agent';
import {connect} from 'react-redux';
import {
  Routes,
  Route,
  useNavigate,
  Navigate,
  useLocation,
} from 'react-router-dom';
import {useMediaQuery} from 'react-responsive';
import {APP_LOAD} from '../constants/actionTypes';
import Article from '../components/Article';
import Editor from '../components/Editor';
import Login from '../components/Login';
import Profile from '../components/Profile';
import ProfileFavorites from '../components/ProfileFavorites';
import Register from '../components/Register';
import ResetPassword from '../components/ResetPassword';
import SetupPassword from '../components/SetupPassword';
import Settings from '../components/Settings';
import Freak from '../components/Freak';
import FreakEditor from '../components/Freak/FreakEditor';
import FreakJoin from './Freak/FreakJoin';
import FreakDetails from './Freak/FreakDetails';
import Notification from "./Notification";
import FixedBottomNavigation from './BottomNavigation';
import BackdropWrapper from './BackdropWrapper';
import FreakPlaces from "./Freak/FreakPlaces";
import FreakCampaigns from "./Freak/FreakCampaigns";
import FreakPlacesEditor from "./Freak/FreakPlacesEditor";

import {useLanguageContext} from "../contexts/LanguageContext";
import ErrorBoundary from "./ErrorBoundary";
import FreakTrackerView from "./Freak/FreakTrackerView";
import {Snackbar} from '@mui/material';
import Slide from '@mui/material/Slide';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import useTranslation from "../customHooks/translations";
import {DEFAULT_THEME_COLOR} from "../constants/theme";
import {getLanguageByBrowser} from "../utils/languageUtils";
import EmailConfirmedView from "./EmailConfirmed/EmailConfirmedView";
import ReportAbuseView from "./ReportAbuse/ReportAbuseView";
import TopFreaksView from "./TopFreaks/TopFreaksView";
import TheFreaksView from "./TheFreaks/TheFreaksView";
import FollowingView from "./Followers/FollowingView";
import FollowedByView from "./Followers/FollowedByView";
import FreakCampaignsEditor from "./Freak/FreakCampaignsEditor";
import FreakCampaignDetails from "./Freak/FreakCampaignDetails";
import FreakDeletedView from "./Freak/FreakDeletedView";
import FreakUnauthorizedView from "./Freak/FreakUnauthorizedView";
import UsersListView from "./UsersList/UsersListView";
import Error401View from "./ErrorsView/Error401View";
import Error404View from "./ErrorsView/Error404View";
import ShortsCreatorComponent from "./FreaksCreator/ShortsCreatorComponent";
import TermsOfService from "./GDPR/TermsOfService";
import PrivacyPolicy from "./GDPR/PrivacyPolicy";
import LeftNavigationComponent from "./LeftNavigation/LeftNavigationComponent";
import ContextSelectViewComponent from "./ContextSelectView/ContextSelectViewComponent";
import FeedsView from "./Feeds/FeedsView";
import { useAuth0 } from "@auth0/auth0-react";
import posthog from 'posthog-js';
import ShakeItView from "./ShakeIt/ShakeItView";
import ShakePricesHistoryView from "./ShakePricesHistory/ShakePricesHistoryView";
import TopFeedsView from "./TopFeeds/TopFeedsView";
import FreakHubView from "./FreakHub/FreakHubView";
import FreakHubDetails from "./FreakHub/FreakHubDetails";
import FreakHubEditor from "./FreakHub/FreakHubEditor";
import FreakHubUsersView from "./FreakHub/FreakHubUsersView";
import FreakPlacesRestricted from "./Freak/FreakPlacesRestricted";
import FreaksRestricted from "./Freak/FreaksRestricted";
import FreakItemDetails from "./FreakItems/FreakItemDetails";
import FreakItemEditor from "./FreakItems/FreakItemEditor";
import { REGISTER, RESTRICTED_PLACES_VIEW_PATH, RESTRICTED_FREAKS_VIEW_PATH } from "../constants/restrictedViews";
import CommonLoader from "./Loaders/CommonLoader";
import AboutView from '../components/About/AboutView';
import TheFreaksGuideView, { THE_FREAKS_GUIDE_PATH } from '../components/TheFreaksGuide/TheFreaksGuideView';
import TheFreaksDemoView from '../components/TheFreaksGuide/TheFreaksDemoView';
import { THE_FREAKS_DEMO_PATH } from '../components/TheFreaksGuide/theFreaksDemoScript';
import ChatInboxView from '../components/Chat/ChatInboxView';
import ChatRoomView from '../components/Chat/ChatRoomView';
import NewDmView from '../components/Chat/NewDmView';
import { CHAT_ENABLED } from '../constants/featureFlags';
import BlastsView from '../components/Blasts/BlastsView';
import AddToHomeScreenBanner from './AddToHomeScreen/AddToHomeScreenBanner';
import FeedbackWidget from './Feedback/FeedbackWidget';
import FeedbackView from './Feedback/FeedbackView';
import AdminFeedbackView from './AdminFeedback/AdminFeedbackView';
import AdminModerationView from './Moderation/AdminModerationView';

const getDevice = (isMobile, isTablet, isDesktop) => {
  let device = '';
  if (isMobile) {
    device = 'mobile';
  } else if (isTablet) {
    device = 'tablet';
  } else if (isDesktop) {
    device = 'desktop';
  }
  return device;
};

function SlideTransition(props) {
  return <Slide {...props} direction="down"/>;
};

const initNotification = async (setSnackbar, translation) => {
  // @todo piush notifications not working weel on PWA

  // setSnackbar({
  //   open: true,
  //   message: translation.notifications.settings,
  //   severity: 'info',
  //   hideOpenButton: false,
  //   link: '/settings'
  // });
};

const App = (props) => {
  const translation = useTranslation();
  const location = useLocation();
  const isMobile = useMediaQuery({maxWidth: 767});
  const isTablet = useMediaQuery({minWidth: 768, maxWidth: 991});
  const isDesktop = useMediaQuery({minWidth: 992});
  const device = getDevice(isMobile, isTablet, isDesktop);
  const navigate = useNavigate();
  const {handleChangeLanguage} = useLanguageContext();
  const context = props?.context || props?.currentUser?.context || 'wof';
  const [snackbar, setSnackbar] = useState({open: false, message: '', severity: 'info', hideOpenButton: false});
  const { appState, isAuthenticated, isLoading, getAccessTokenSilently} = useAuth0();
  const [loading, setLoading] = useState(true);
  const redirectTo = new URLSearchParams(location.search).get('redirectTo') || '/freak';

  useEffect(() => {
    if (props.redirectTo) {
      navigate(props.redirectTo);
    }
  }, [props.redirectTo]);

  useEffect(() => {
    if (isLoading) return;

    const initApp = async () => {
      console.log('[DEBUG LOG] Init App', { loading, pathname: location?.pathname});

      if (
        location?.pathname !== '/' &&
        location?.pathname !== RESTRICTED_PLACES_VIEW_PATH &&
        location?.pathname !== RESTRICTED_FREAKS_VIEW_PATH &&
        location?.pathname !== REGISTER &&
        location?.pathname !== '/about' &&
        location?.pathname !== THE_FREAKS_GUIDE_PATH &&
        location?.pathname !== THE_FREAKS_DEMO_PATH &&
        location?.pathname !== '/feedback'
      ) {
        console.log('[DEBUG LOG] Not places restricted', { loading, pathname: location?.pathname});

        try {
          // DEV impersonation (see api/debugging/impersonate.sh): skip the Auth0 login and let
          // the locally-bypassed API resolve the user from GET /user. Inert unless the
          // REACT_APP_IMPERSONATE env flag is set, so normal builds are unaffected.
          const token = process.env.REACT_APP_IMPERSONATE === 'true'
            ? 'dev-impersonation'
            : await getAccessTokenSilently();
          if (token) {
            agent.setToken(token);
          }
          const user = await agent.Auth.current();
          if (user?.user?.email) {
            posthog.identify(user.user.email);
          }
          props.onLoad(token ? user : null, token, device, context);

          if (token && !window.cordova) {
            initNotification(setSnackbar, translation);
          }

          handleChangeLanguage(props.currentUser?.language || getLanguageByBrowser());

          if (!props.newThemeMode && props.currentUser?.themeMode) {
            props.handleTheme(props.currentUser?.themeMode);
          } else if (props.newThemeMode && props.newThemeMode !== props.currentUser?.themeMode) {
            props.handleTheme(props.newThemeMode);
          }
        } catch (error) {
          // Public-viewable pages should still render for logged-out users
          // instead of bouncing to login when there is no Auth0 session. We
          // still attempt auth above so logged-in users keep personalization.
          if (location?.pathname !== '/blasts') {
            navigate(`/login?redirectTo=${redirectTo}`);
          }
        } finally {
          setLoading(false);
          console.log('[DEBUG LOG] App loaded', { loading, pathname: location?.pathname});
        }
      } else {
        setLoading(false);
      }
    };

    initApp();
  }, [isLoading])

  const handleClose = () => {
    setSnackbar({...snackbar, open: false});
  };

  console.log('[DEBUG LOG] Before load', { loading, pathname: location?.pathname});
  if (loading) {
    return <CommonLoader fullScreen />
  }

  return (
    <ErrorBoundary>
      {
        <>
          <Routes>
            <Route path="/" element={<Navigate to="/about"/>}/>
            <Route path="/login" element={<Login/>}/>
            <Route path="/register" element={<Register/>}/>
            <Route path="/reset-password" element={<ResetPassword/>}/>
            <Route path="/setup-password" element={<SetupPassword/>}/>
            <Route path="/editor/:slug" element={<Editor/>}/>
            <Route path="/editor" element={<Editor/>}/>
            <Route path="/article/:id" element={<Article/>}/>
            <Route path="/settings" element={<Settings handleTheme={props.handleTheme}/>}/>
            <Route path="/notifications" element={<Notification/>}/>
            <Route path="/:username/favorites" element={<ProfileFavorites/>}/>
            <Route path="/:username" element={<Profile/>}/>
            <Route path="/freak" element={<Freak context={context} initializing={loading}/>}/>
            <Route path="/freak/:id" element={<FreakDetails context={context}/>}/>
            <Route path="/freak-editor/:slug" element={<FreakEditor/>}/>
            <Route path="/freak-editor" element={<FreakEditor context={context}/>}/>
            <Route path="/freak-join/:slug" element={<FreakJoin/>}/>
            <Route path="/freak-items/:slug" element={<FreakItemDetails/>}/>
            <Route path="/freak-items-editor" element={<FreakItemEditor/>}/>
            <Route path="/freak-items-editor/:slug" element={<FreakItemEditor/>}/>
            <Route path="/places" element={<FreakPlaces context={context}/>}/>
            <Route path="/places-restricted" element={<FreakPlacesRestricted context={context}/>}/>
            <Route path="/freaks-restricted" element={<FreaksRestricted context={context}/>}/>
            <Route path="/places-editor/:slug" element={<FreakPlacesEditor context={context}/>}/>
            <Route path="/places-editor" element={<FreakPlacesEditor context={context}/>}/>
            <Route path="/campaigns" element={<FreakCampaigns context={context}/>}/>
            <Route path="/campaigns/:id" element={<FreakCampaignDetails/>}/>
            <Route path="/campaigns-editor" element={<FreakCampaignsEditor context={context}/>}/>
            <Route path="/campaigns-editor/:slug" element={<FreakCampaignsEditor context={context}/>}/>
            <Route path="/record" element={<FreakTrackerView/>}/>
            <Route path="/email-confirmed" element={<EmailConfirmedView/>}/>
            <Route path="/report-abuse/:slug" element={<ReportAbuseView/>}/>
            <Route path="/top-freaks" element={<TopFreaksView/>}/>
            <Route path="/the-freaks" element={<TheFreaksView/>}/>
            <Route path="/following/:username" element={<FollowingView/>}/>
            <Route path="/followed-by/:username" element={<FollowedByView/>}/>
            <Route path="/freak-deleted" element={<FreakDeletedView/>}/>
            <Route path="/freak-unathorized" element={<FreakUnauthorizedView/>}/>
            <Route path="/users-list" element={<UsersListView/>}/>
            <Route path="/401" element={<Error401View/>}/>
            <Route path="/404" element={<Error404View/>}/>
            <Route path="/create-shorts" element={<ShortsCreatorComponent/>}/>
            <Route path="/terms-of-service" element={<TermsOfService/>}/>
            <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
            <Route path="/about" element={<AboutView/>}/>
            <Route path={THE_FREAKS_GUIDE_PATH} element={<TheFreaksGuideView/>}/>
            <Route path={THE_FREAKS_DEMO_PATH} element={<TheFreaksDemoView/>}/>
            <Route path="/feedback" element={<FeedbackView/>}/>
            {CHAT_ENABLED && <Route path="/chat" element={<ChatInboxView/>}/>}
            {CHAT_ENABLED && <Route path="/chat/new" element={<NewDmView/>}/>}
            {CHAT_ENABLED && <Route path="/chat/dm/:dmUsername" element={<ChatRoomView/>}/>}
            {CHAT_ENABLED && <Route path="/chat/:roomId" element={<ChatRoomView/>}/>}
            <Route path="/user-feeds/:username/:social" element={<FeedsView/>}/>
            <Route path="/context-change" element={<ContextSelectViewComponent/>}/>
            <Route path="/shake-it" element={<ShakeItView/>}/>
            <Route path="/blasts" element={<BlastsView/>}/>
            <Route path="/prices-history" element={<ShakePricesHistoryView/>}/>
            <Route path="/top-feeds" element={<TopFeedsView/>}/>
            <Route path="/freak-hub" element={<FreakHubView context={context}/>}/>
            <Route path="/freak-hub/:slug" element={<FreakHubDetails context={context}/>}/>
            <Route path="/freak-hub/:slug/users" element={<FreakHubUsersView context={context}/>}/>
            <Route path="/freak-hub-editor" element={<FreakHubEditor context={context}/>}/>
            <Route path="/freak-hub-editor/:slug" element={<FreakHubEditor context={context}/>}/>
            <Route path="/admin/feedback" element={<AdminFeedbackView/>}/>
            <Route path="/admin/moderation" element={<AdminModerationView/>}/>
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>

          {location.pathname !== '/about' && location.pathname !== THE_FREAKS_GUIDE_PATH && location.pathname !== THE_FREAKS_DEMO_PATH && location.pathname !== '/feedback' && !location.pathname.startsWith('/chat') && (
            isDesktop ? <LeftNavigationComponent/> : <FixedBottomNavigation />
          )}
          {location.pathname !== THE_FREAKS_DEMO_PATH && <FeedbackWidget />}

          <Snackbar
            open={snackbar.open}
            variant={'solid'}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{vertical: 'top', horizontal: 'right'}}
            sx={{
              marginTop: 7,
            }}
            TransitionComponent={SlideTransition}
            message={snackbar.message}
            action={
              <React.Fragment>
                {
                  snackbar.hideOpenButton
                    ? null
                    : <Button
                      style={{
                        backgroundColor: DEFAULT_THEME_COLOR,
                        color: 'white'
                      }}
                      sx={{
                        outline: 'none',
                        '&:focus': {
                          outline: 'none'
                        },
                        '&:hover': {
                          color: DEFAULT_THEME_COLOR,
                          borderColor: DEFAULT_THEME_COLOR,
                        },
                      }}
                      size="small"
                      onClick={() => {
                        snackbar.link ? navigate(snackbar.link) : navigate('/notifications')
                      }}>
                      {translation.snackbar.open}
                    </Button>
                }
                <IconButton
                  aria-label="close"
                  style={{
                    color: DEFAULT_THEME_COLOR
                  }}
                  sx={{p: 0.5}}
                  onClick={handleClose}
                >
                  <CloseIcon/>
                </IconButton>
              </React.Fragment>
            }
          >
          </Snackbar>

          {isMobile && !['/login', '/register', '/about', THE_FREAKS_GUIDE_PATH, THE_FREAKS_DEMO_PATH].includes(location.pathname) && (
            <AddToHomeScreenBanner />
          )}
        </>
      }
      {!['/login', '/register', '/about', THE_FREAKS_GUIDE_PATH, THE_FREAKS_DEMO_PATH, '/places-restricted'].includes(location.pathname) && !location.pathname.startsWith('/chat') && <BackdropWrapper/>}
    </ErrorBoundary>
  );
};

const mapStateToProps = state => {
  return {
    appLoaded: state.common.appLoaded,
    appName: state.common.appName,
    currentUser: state.common.currentUser,
    redirectTo: state.common.redirectTo,
    device: state.common.device,
    context: state.common.context,
    newThemeMode: state.common.newThemeMode,
  }
};

const mapDispatchToProps = dispatch => ({
  onLoad: (payload, token, device, context) => {
    dispatch({type: APP_LOAD, payload, token, skipTracking: true, device})
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
